<section *ngIf="currentMessage && transactionObject.transactionStatus=='SUCCESS'" class="py-5">
    <div class="text-center img-block mt-5">
        <img src="assets/images/products/TravelInsurance.png" alt="" loading="lazy">
    </div>
    <div class="text-center">
        <h4>{{ currentMessage }}</h4>
    </div>
</section>
<section class="container-payment-body" *ngIf="transactionObject.transactionStatus == 'FAILED'">
    <div class="container-payment">
        <!-- <div *ngIf="transactionObject.transactionStatus=='SUCCESS'" >
            <h2 class="text-center bold-header mb-2" >Payment Confirmtion</h2>
            <p class="text-center" ><em class="fa fa-check-circle fa-2x blink fa-5x text-success" aria-hidden="true"></em></p>
            <p class="text-center mt-2 mb-2">{{transactionObject.transactionStatus}}</p>
            <p class="text-center mt-2 mb-2">Transaction Reference : {{transactionObject.transactionReference}}</p>
            <p class="text-center mt-2 mb-2">Your Payment has been completed Successfully</p>
            <div class="row justify-content-center">
                <div class="col-12 col-sm-10 col-md-8 col-lg-3 col-xl-3">
                    <button class="btn btn-primary btn-sm" (click)="routeToHome()" >Home</button>
                </div>
            </div>
        </div> -->

        <div>
            <h2 class="text-center bold-header mb-2">Payment Confirmtion</h2>
            <p class="text-center"><em class="fa-solid fa-thumbs-down fa-2x fa-5x text-primary"></em></p>
            <p class="text-center mt-2 mb-2">{{transactionObject.transactionStatus}}</p>
            <p class="text-center mt-2 mb-2">Transaction Reference : {{transactionObject.transactionReference}}</p>
            <p class="text-center mt-2 mb-2">Your Payment is Failed</p>
            <div class="row justify-content-center">
                <div class="col-12 col-sm-10 col-md-8 col-lg-3 col-xl-3">
                    <button class="btn btn-primary btn-sm" (click)="routeToHome()">Retry</button>
                </div>
            </div>
        </div>
    </div>
</section>